<!-- title -->
<app-modal-title
  [title]="title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="tw-w-[300px]">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <!-- title -->
          <form-field
            [(value)]="model.title"
            class="tw-w-full tw-mb-2"
            [control]="form?.get('title')"
            label="common.title"
          >
          </form-field>

          <sms-template-group-select-search
            class="tw-w-full"
            label="common.group"
            [control]="form?.get('smsTemplateGroupId')"
            [(value)]="model.smsTemplateGroupId"
            (onError)="onClose()"
          >
          </sms-template-group-select-search>

          <!-- counter -->
          <div class="md:tw-w-full tw-mt-1 tw-mb-2">
            <list-group-item
              [label]="'common.characterCount' | translate"
              [value]="smsLength"
            >
            </list-group-item>

            <list-group-item
              [label]="'common.partCount' | translate"
              [value]="smsCount"
            >
            </list-group-item>
          </div>

          <!-- sms body -->
          <div class="md:tw-w-full tw-mt-1 tw-w-full">
            <div class="tw-flex">
              <form-textarea
                class="tw-w-full"
                label="common.smsBody"
                [(value)]="model.body"
                [control]="form?.get('body')"
                [rows]="5"
                (valueChange)="getSmsCount()"
                [spellcheck]="false"
              >
              </form-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
